export const phoneVerification = {
  'phone_verification.page_title': 'Ověření telefonního čísla',
  'phone_verification.title': 'Ověření telefonního čísla',
  'phone_verification.info':
    'Na tel. číslo <b>{phoneNumber}</b> jsme zaslali 4-místný SMS kód. Opište prosím kód z SMS pro ověření telefonu.',
  'phone_verification.edit_phone_number': 'Upravit tel. číslo',
  'phone_verification.verify_phone_number': 'Ověřit tel. číslo',
  'phone_verification.input_label': 'Kód z SMS',
  'phone_verification.input_placeholder': 'Zadejte kontrolní kód',
  'phone_verification.text_under_input': 'Nedostali jste SMS kód?',
  'phone_verification.request_new_code': 'Poslat nový kód',
  'phone_verification.validation.required': 'Toto pole je povinné',
  'phone_verification.validation.4_digits': 'Kód musí být 4 číslice',
  'phone_verification.errors.verification_failed':
    'Ověření selhalo. Překontrolujte zadaný kód a zkuste to znovu, nebo si nechte zaslat nový.',
  'phone_verification.errors.request_failed':
    'Došlo k chybě na naší straně. Zkuste to prosím znovu později.',
  // update contact modal
  'phone_verification.update_contact_modal.title': 'Úprava telefonního čísla',
  'phone_verification.update_contact_modal.title_mobile':
    'Úprava<br></br>telefonního čísla',
  'phone_verification.update_contact_modal.description':
    'Po změně tel. čísla pošleme SMS kód na nově zadané číslo.',
  'phone_verification.update_contact_modal.labels.full_name':
    'Jméno a příjmení',
  'phone_verification.update_contact_modal.labels.email': 'E-mail',
  'phone_verification.update_contact_modal.labels.phone': 'Telefon',
  'phone_verification.update_contact_modal.submit_button': 'Upravit tel. číslo',
  'phone_verification.update_contact_modal.error':
    'Kontakt se nepodařilo upravit. Zkuste to prosím znovu později.',
  'phone_verification.new_code_requested':
    'Kód byl úspěšně odeslán. Doručení může pár minut trvat.',
};
